import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { throwError } from 'rxjs';

/** Título do toast (summary); a mensagem vai no detail, abaixo dele. */
const TITULO_POR_SEVERIDADE: Record<string, string> = {
  success: 'Sucesso',
  info: 'Informação',
  warn: 'Atenção',
  error: 'Erro',
};

export const TITULO_ERRO_CONECTIVIDADE = 'Falha de comunicação com o Gestor IDSS';

export const MENSAGEM_ERRO_CONECTIVIDADE = [
  'Seu computador ou sua rede não está conseguindo se comunicar com os serviços do Gestor IDSS.',
  '',
  '1. Teste o acesso em outra rede (ex.: compartilhamento de internet do celular ou rede doméstica).',
  '2. Se funcionar fora da rede da operadora, peça à equipe de TI para verificar bloqueios de firewall ou proxy e liberar os endereços:',
  'https://app.idss.com.br:443',
  'https://auth.idss.com.br:8443',
  'https://api.idss.com.br:443',
  'https://api.idss.com.br:1443',
].join('\n');

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private _messageService: MessageService) {}

  clear() {
    this._messageService.clear();
  }

  info(message: string, extraConfig?: ToastMessageOptions) {
    this.buildMessage('info', message, extraConfig);
  }

  success(message: string, extraConfig?: ToastMessageOptions) {
    this.buildMessage('success', message, extraConfig);
  }

  warn(message: string, extraConfig?: ToastMessageOptions) {
    this.buildMessage('warn', message, extraConfig);
  }

  error(message: string, extraConfig?: ToastMessageOptions) {
    this.buildMessage('error', message, extraConfig);
  }

  handleError(error: Error | HttpErrorResponse, message?: string, extraConfig?: ToastMessageOptions) {
    if (error instanceof HttpErrorResponse && error.status === 0) {
      this.erroConectividade();
      return throwError(() => error);
    }

    if (!message && error instanceof HttpErrorResponse) {
      message = error.error?.message ?? error.error?.error;
    }
    if (!message) {
      message = error.message;
    }
    this.buildMessage('error', message, extraConfig);
    return throwError(() => error);
  }

  private buildMessage(severity: string, message: string, extraConfig?: ToastMessageOptions) {
    this._messageService.add({ severity, summary: TITULO_POR_SEVERIDADE[severity], detail: message, ...(extraConfig ?? {}) });
  }

  private erroConectividade() {
    this._messageService.add({
      severity: 'error',
      summary: TITULO_ERRO_CONECTIVIDADE,
      detail: MENSAGEM_ERRO_CONECTIVIDADE,
      sticky: true,
      closable: true,
      styleClass: 'bl-toast-conectividade',
    });
  }
}
